// TODO implement
const useViewModel = (props) => props;

export { useViewModel };
